const BackIcon = () => {
    return (
        <svg className="inline-block" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.8327 6.99996H1.16602M1.16602 6.99996L6.99935 12.8333M1.16602 6.99996L6.99935 1.16663" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
  };
  
  export default BackIcon;
  

